import { Stylable } from 'utils/types'
import { EstimatedValue, StyledInput } from './styles'

interface Props extends Stylable {
  inputText: string
  disabled?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  currency?: string
  placeholder?: string
  estimatedValue?: string
  ref?: React.Ref<HTMLElement>
}

export const Input = ({ inputText, onChange, disabled, placeholder, style, estimatedValue, ref }: Props) => (
  <div style={{ position: 'relative', ...style }}>
    <StyledInput value={inputText} onChange={onChange} placeholder={placeholder} disabled={disabled} ref={ref} />
    <EstimatedValue variant="caption" color="secondary" style={{ textAlign: 'right' }}>
      {estimatedValue}
    </EstimatedValue>
  </div>
)
